import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { CombinedFunnelMobile } from '../CombinedFunnelMobile/CombinedFunnelMobile'
import { CreateFlowcodeFormDesktop } from './CreateFlowcodeFormDesktop'
import { CreateFlowcodeFormProvider } from './CreateFlowcodeFormContext'
import { FC } from 'react'
import { GeneratorBannerDesktopV2, GeneratorBannerMobile } from '../GeneratorBanner'
import { PrismicAPIResp } from '../HomepageStaticContent/types'
import { ResponsiveBox } from '../../utils/responsive-box'
import { useCodeSelector } from '@dtx-company/inter-app/src/hooks/useCodeSelector'
import { useFlowcodeTemplates } from './CreateFlowcodeForm.hooks'
import { useGeneratorBannerData } from '../GeneratorBanner/hooks'
import { useIsDesktop } from '@dtx-company/true-common/src/hooks/useIsDesktop'
import { useIsMounted } from '@dtx-company/true-common/src/hooks/useIsMounted'

const MobileVariants: FC = () => {
  return <CombinedFunnelMobile />
}

export const CreateFlowcodeForm: FC<{
  data: PrismicAPIResp[]
}> = ({ data }) => {
  useFlowcodeTemplates()

  const showMobileSignupStep = useCodeSelector(state => state.homePage.showMobileSignupStep)
  const { generatorBannerDesktopData, generatorBannerMobileData } = useGeneratorBannerData(data)

  const isDesktop = useIsDesktop()
  const isMounted = useIsMounted()
  const displayDesktopGenerator = !isMounted() || isDesktop
  const displayMobileGenerator = !isMounted() || !isDesktop

  return (
    <>
      {!showMobileSignupStep && (
        <Box display={['block', 'block', 'block', 'none']}>
          <GeneratorBannerMobile data={generatorBannerMobileData} />
        </Box>
      )}
      <Box display={['none', 'none', 'none', 'block']}>
        <GeneratorBannerDesktopV2 data={generatorBannerDesktopData} />
      </Box>
      <CreateFlowcodeFormProvider>
        <ResponsiveBox mobile="block" tablet="block" desktop="none">
          {displayMobileGenerator && <MobileVariants />}
        </ResponsiveBox>
        <ResponsiveBox mobile="none" tablet="none" desktop="block">
          {displayDesktopGenerator && <CreateFlowcodeFormDesktop />}
        </ResponsiveBox>
      </CreateFlowcodeFormProvider>
    </>
  )
}
